import { PageController } from '@client/components/_core/layout/PageController';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { useAuthStore } from '@client/stores/AuthStore';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

export const Route = createFileRoute('/(authentication)/logout')({
    component: Logout,
});

function Logout() {
    const navigate = useNavigate();
    const authStore = useAuthStore();

    useEffect(() => {
        authStore.logout('user_initiated').then(() => {
            navigate({ to: '/login' });
        });
    }, []);

    return <PageController route={Route}>{null}</PageController>;
}
